import styles from "./CaseStudyModal.module.scss";
import {
  UserOutlined,
  WarningOutlined,
  SettingFilled,
  BarChartOutlined,
  TrophyOutlined
} from "@ant-design/icons";

const CaseStudyContent = ({ data }) => {
  const BannerImage = data.image;

  return (
    <div className={styles.caseStudyContainer}>
      <div className={styles.header}>
        <div className={styles.leftContent}>
          <h1 className={styles.caseStudyTitle}>
            Case Study: {data.title}
          </h1>

          <div className={styles.clientSection}>
            <UserOutlined />
            <span>
              <strong>Client: </strong>
              <span className={styles.clientNameBSES}>
                {data.client}
              </span>
            </span>
          </div>

          <p className={styles.description}>
            {data.description}
          </p>
        </div>

        <div className={styles.bannerImage}>
          <BannerImage />
        </div>
      </div>

      <div className={styles.gridSection}>
        <div className={`${styles.card} ${styles.problemCard}`}>
          <h2 className={styles.problemTitle}>
            <WarningOutlined />
            Problem Statement
          </h2>

          <ul className={styles.problemList}>
            {data.problemPoints.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        <div className={`${styles.card} ${styles.solutionCard}`}>
          <h2 className={styles.solutionTitle}>
            <SettingFilled />
            Our Solution
          </h2>

          <div className={styles.solutionList}>
            {data.solutions.map((item, index) => (
              <div
                key={index}
                className={styles.solutionItem}
              >
                <div className={styles.solutionNumber}>
                  {String(index + 1).padStart(2, "0")}
                </div>

                <div className={styles.solutionText}>
                  {item}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className={styles.impactCard}>
        <h2>
          <BarChartOutlined />
          Impact Delivered
        </h2>

        <div className={styles.impactGrid}>
          {data.impacts.map((impact, index) => (
            <div
              key={index}
              className={styles.impactItem}
            >
              <h3>{impact.value}</h3>
              <span>{impact.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.footerCard}>
        <div>
          <TrophyOutlined />
          <strong> Outcome:</strong>
          {data.outcome}
        </div>

        <div>
          <strong>Technology Used:</strong>
          {data.technology}
        </div>
      </div>
    </div>
  );
};

export default CaseStudyContent;